import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'

export default function Switch({ uuid, value, handleChange, disabled = false, label = null }) {
  const translateEntry = useTranslateEntry()

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        name={uuid}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
        className="sr-only peer"
        aria-label={label || translateEntry('T_COOKIE_SWITCH')}
      />
      <div className="w-[52px] h-[27px] bg-blueish-blueish2 peer-focus:ring-2 peer-focus:ring-functional-focus-color rounded-full peer peer-checked:bg-green-green2 transition-colors peer-disabled:bg-blueish-blueish2 peer-disabled:peer-checked:bg-blueish-blueish2 shadow-[inset_2px_2px_4px_0px_#787878]"></div>
      <div className="shadow-[0px_0px_8px_0px_#0000004D] absolute left-[4px] top-[3px] w-[21px] h-[21px] bg-basic-white rounded-full transition-transform peer-checked:translate-x-24 peer-disabled:bg-basic-gray8"></div>
    </label>
  )
}
